import searchTermsAndTunerView from './searchTermsAndTunerComponent.html';
import './searchTermsAndTunerComponent.css';
import _ from 'lodash';

export function searchTermsAndTunerComponent() {
	return {
		bindings: {
			searchTerm: '=',
			search: '=',
			callback: '&',
			fineTunerClosed: '=',
			enableSearch: '<?',
		},
		controllerAs: 'vm',
		controller: searchTermsAndTunerComponentCtrl,
		template: searchTermsAndTunerView,
	};
}

export class searchTermsAndTunerComponentCtrl {
	constructor($timeout, $scope) {
		'ngInject';
		this.$timeout = $timeout;
		$scope.$watch('vm.search.term', (newVal, oldVal, $scope) => {
			if (newVal || newVal == oldVal) {
				return null;
			}
			this.searchTerm = newVal;
		});
		this.$timeout(() => {
			this.hasApplied = !!_.get(this, 'searchTerm', false);
		});
	}

	handleSubmit() {
		this.callback();
		this.hasApplied = true;
	}

	shouldEnableClear() {
		if (!this.hasApplied || !this.searchTerm) {
			return false;
		}

		return true;
	}

	clearSearch() {
		this.hasApplied = false;
		this.searchTerm = '';
		this.$timeout(() => {
			this.callback();
		});
	}
}
